import React from "react";
import * as icons from "./SocialIcon";
import UIButton from '../../../../globalComponents/UIComponents/UIButton';

export const services = ['sso', 'vk', 'ok', 'yandex', 'mailru', 'google', 'twitter', 'linkedin', 'facebook'];

const logos = {
    vk: icons.Vk,
    ok: icons.Ok,
    twitter: icons.Twitter,
    google: icons.Google,
    linkedin: icons.LinkedIn,
    mailru: icons.MailRu,
    yandex: icons.Yandex,
    local: () => 'LC'
};

export const SocialLogin = ({name = 'sso', eventKey, ssoIconUrl, participationType = 'online', $locale, isSsoAuthOnly}) => {
    const handleClick = () => {
        window.open(`/api/player/login/${name}?eventKey=${eventKey}&participationType=${participationType}`, 'SignIn',
            'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=400px,height=400px'
        );
    };

    if ('sso' === name) {
        const style = {
            background: `no-repeat center url(${ssoIconUrl})`,
            backgroundSize: 'cover',
        }

        return (
            <div className="social-logo-container">
                <UIButton
                    style={`social-logo ${isSsoAuthOnly ? 'social-logo--sso-only' : 'social-logo--sso'}`}
                    customStyles={ssoIconUrl ? style : {}}
                    onClick={handleClick}
                >
                    {$locale.get('auth.sso.button')}
                </UIButton>
            </div>
        );
    }

    const Logo = logos[name];
    if (!Logo) {
        return null;
    }

    return (
        <button onClick={handleClick} className={`social-logo`}>
            <Logo />
        </button>
    );
}
